import { Promotion } from "@/_models/promotion.interface";
import { DateUtils } from "@/_utility/DateTimeFormat";
import { CombinedTaskCardMobileComponent } from "@/components/shared/flight-list/combined-task-card-mobile/combined-task-card-mobile.component";
import { SharedComponentsModule } from "@/components/shared/shared-components.module";
import { Component, Input, OnInit } from "@angular/core";
import { AsyncPipe } from "@angular/common";
import { UserService } from "@/_services";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Component({
    selector: "app-promotion-task-card",
    standalone: true,
    imports: [
        SharedComponentsModule,
        CombinedTaskCardMobileComponent,
        AsyncPipe,
    ],
    templateUrl: "./promotion-task-card.component.html",
    styleUrls: [
        "./promotion-task-card.component.scss",
        "../home-task-card/home-task-card.component.scss",
    ],
})
export class PromotionTaskCardComponent implements OnInit {
    @Input() promotion: Promotion;
    @Input() showEdit: boolean = false;

    isCreator$: Observable<boolean>;

    constructor(
        public dateUtils: DateUtils,
        private userService: UserService,
    ) {}

    ngOnInit() {
        this.isCreator$ = this.userService
            .getCurrentUserAsync()
            .pipe(
                map(
                    (currentUser) =>
                        currentUser?._id === this.promotion?.creator?._id,
                ),
            );
    }
}
